const CobaComp = () => {
    return (
        <div className="pt-5 mt-5">
            <h1>ini coba</h1>
        </div>
    );
};

export default CobaComp;
